import React from 'react';
import customComponents from './components';

import './css/custom-content-component.less';

export default class CustomContent extends React.Component{
    render(){
        const { components = [], disclaimers=[], device, sku } = this.props;
        const isMobile = device === "mobile";
        return(
            <div className='custom-content'>
            {
                components.map((component, i) => {
                    const CustomComponent = customComponents[component.type];
                    return(
                        <CustomComponent
                            key={`custom-component-${i}`}
                            disclaimers={disclaimers}
                            isMobile={isMobile}
                            sku={sku}
                            {...component.data}
                        />
                    )
                })
            }
            </div>
        );
    }
};
